import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { maritimeForecastKeys } from "@/features/dashboard/components/warnings/maritime-forecast.queries";
import { MaritimeForecastDomainId } from "@/features/dashboard/components/warnings/maritime-forecast.domains";
import { useRefreshAction } from "@/features/dashboard/features/refresh-timer/hooks";

const useRefetchMaritimeForecast = (domainId: MaritimeForecastDomainId) => {
  const queryClient = useQueryClient();

  const refresh = useCallback(async () => {
    await queryClient.refetchQueries({
      queryKey: maritimeForecastKeys.forecast(domainId),
    });
  }, [domainId, queryClient]);

  useRefreshAction(refresh);
};

export default useRefetchMaritimeForecast;
